<template>
  <div class="parent ml-3">
    <div class="ml-3" style="display: flex; justify-content: center; align-items: baseline">
      <p v-if="+(activeUserId ?? 0) == 101" style="font-size: 16px">{{ $t("dropDownComp.defaultColor") }}</p>
      <select
        :disabled="true"
        v-if="options != null"
        v-model="defaultColor"
        @change="$emit('changeDefaultColorSelectorValue', defaultColor)"
        style="
          margin-left: 1rem;
          font-family: Arial, sans-serif;
          border-radius: 4px;
          height: 28px;
          border-color: rgb(191, 198, 203);
          width: 122px;
        "
        id="defaultColor"
        :aria-label="$t('dropDownComp.defaultColor')"
      >
        <option v-for="option in options" :key="option.Id" :value="option.name">
          {{ option.value }}
        </option>
      </select>
    </div>
    <div style="display: flex; justify-content: center; align-items: baseline">
      <p v-if="+(activeUserId ?? 0) == 101" style="font-size: 16px">{{ $t("dropDownComp.shadeConfiguartion") }}</p>
      <Toggle :toggleValue="toggleButtonVal" @onToggleChange="toggleEvent"> </Toggle>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import Toggle from "./Toggle.vue";

export default defineComponent({
  name: "DropdownComp",
  components: {
    Toggle
  },
  props: {
    options: {
      type: Array as () => any[]
    },
    toggleButtonVal: null,
    selectedDefaultColor: null
  },
  emits: ["changeDefaultColorSelectorValue", "toggleEventChange"],
  data() {
    return {
      activeUserId: sessionStorage.getItem("activeUserId"),
      defaultColor: null as any
    };
  },
  watch: {
    selectedDefaultColor(newVal) {
      this.defaultColor = newVal;
    }
  },
  methods: {
    toggleEvent(value: boolean): void {
      this.$emit("toggleEventChange", value);
    }
  }
});
</script>

<style scoped>
.parent {
  display: flex !important;
  align-items: baseline;
  justify-content: space-between;
}
</style>
